function parseBloomreachImage(image) {
  if (!image) {
    return void 0;
  }
  return {
    alt: image.description ?? "",
    original: {
      alt: image.description ?? "",
      url: image.original?.url || "",
      dimensions: getDimensions(image.original)
    },
    mobile: {
      alt: image.description ?? "",
      url: image.mobile?.url || "",
      dimensions: getDimensions(image.mobile)
    }
  };
}
function getDimensions(input) {
  return { w: input?.width || 0, h: input?.height || 0 };
}
export {
  parseBloomreachImage
};
//# sourceMappingURL=parse-bloomreach-image.js.map
